export default __webpack_public_path__ + "static/media/token.bd355c79.svg";